import { ExclamationCircleOutlined, ReloadOutlined } from "@ant-design/icons";
import { Button, Typography } from "antd";
import { Flex } from "../../../common/components/flex/flex";

export const SectionError = ({
  title = "Failed to load section",
  message = "Something went wrong",
  onRetry = null,
}) => (
  <Flex
    direction="column"
    align="center"
    justify="center"
    style={{ width: "100%", height: "100%", minHeight: "inherit" }}
  >
    <Flex direction="column" align="center" gap={12}>
      <Flex direction="column" align="center" gap={4}>
        <Flex align="center" gap={8}>
          <ExclamationCircleOutlined style={{ color: "red", fontSize: 20 }} />
          <Typography.Title level={5} style={{ margin: 0 }}>
            {title}
          </Typography.Title>
        </Flex>

        <Typography.Text type="secondary">{message}</Typography.Text>
      </Flex>

      {onRetry && (
        <Button icon={<ReloadOutlined />} onClick={onRetry}>
          Retry
        </Button>
      )}
    </Flex>
  </Flex>
);
